module.exports = __webpack_public_path__ + "img/light_top_bg.feab4072.png";